import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

/**
 * Rădăcina rutelor. Nu desenează nimic în jurul paginii: antetul aparține stratului
 * `_authenticated`, pentru că `/login` nu trebuie să aibă meniu.
 *
 * `QueryClient` intră în contextul rutelor ca `beforeLoad` să poată cere sesiunea
 * **înainte** de a randa ceva. Cu un client importat direct dintr-un modul, testele n-ar
 * mai putea da altul.
 */
export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Outlet,
});
